// extracted by mini-css-extract-plugin
export default {"content":"CGU_content__iD+XE"};